// Sélection de thème (Gold/Silver/Navy/Blanc, voir taskpane.css [data-theme]) -- persistée en
// localStorage, aucune dépendance sur le reste de l'état applicatif.
const THEME_STORAGE_KEY = "praetor-theme";

export function getStoredTheme(): string {
  try {
    return localStorage.getItem(THEME_STORAGE_KEY) || "navy";
  } catch {
    return "navy";
  }
}

export function applyTheme(theme: string): void {
  if (theme && theme !== "navy") {
    document.documentElement.setAttribute("data-theme", theme);
  } else {
    document.documentElement.removeAttribute("data-theme");
  }
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // stockage indisponible (mode privé, etc.) : le thème reste appliqué pour cette session
  }
}
